module.exports = __webpack_public_path__ + "b08b52b67543d7cb8159679b47fb4f6d.fbx";